import Translator from '../../../Shared/translator';
import v1_v2 from './v1_v2';
import v2_v3 from './v2_v3';
import v3_v4 from './v3_v4';
import v4_v5 from './v4_v5';

const translator: Translator = {
  ['v1_v2']: v1_v2,
  ['v2_v3']: v2_v3,
  ['v3_v4']: v3_v4,
  ['v4_v5']: v4_v5
};

export default translator;
